import apiClient from './api';

export default {
  submitEnquiry(enquiry) {
    // Format the enquiry to match what your Django API expects
    const formattedEnquiry = {
      your_email: enquiry.email,
      your_telephone: enquiry.telephone || '',
      your_name: enquiry.name || '',
      your_company: enquiry.company || '',
      your_message: enquiry.note || ''
    };

    // Use URLSearchParams for form data submission
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(formattedEnquiry)) {
      params.append(key, value);
    }

    // Get the CSRF token from cookies
    const csrfToken = this.getCookie('csrftoken');

    // Set headers for form submission with CSRF token
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-CSRFToken': csrfToken
    };

    return apiClient.post('/learn-more-submit/', params, { headers });
  },

  getEnquiries() {
    return apiClient.get('/enquiries/');
  },

  getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }
};